import { useQuery } from '@tanstack/react-query';
import { useConfigId } from '../../context/ConfigContext';
import { ApiError } from '../../lib/api';
import { getLocalizationBundles } from '../../services/backendService';
import { LocalizationBundle } from '../../types/localizationBundle.types';

export const useLocalization = () => {
  const { configId } = useConfigId();

  return useQuery<LocalizationBundle[], ApiError>({
    queryKey: ['localizationBundles', configId],
    queryFn: () => getLocalizationBundles({ configId: configId! }),
    enabled: !!configId,
  });
};
